module.exports = __webpack_public_path__ + "static/img/shibai.8408692.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/check/shibai.png
// module id = jlWV
// module chunks = 1